import { fromJS, List } from 'immutable';
import Activity from 'models/ActivityModel';
import { createReducer } from '../../utils/helpers';
import { activities } from './types';

const initialState = fromJS({
  data: null,
  loading: true,
  error: false,
});

export default createReducer(initialState, {
  [activities.request]: (state) => state.set('loading', true),
  [activities.success]: (state, action) =>
    state
      .set('loading', false)
      .set('error', false)
      .set(
        'data',
        new List(action.response).map((activity) => Activity.deserialize(activity)),
      ),
  [activities.failure]: (state, action) => state.set('loading', false).set('error', action.error),
});
